import React from 'react';
import cn from 'classnames';

import {Contentful} from 'brand/app/contentful/components';
import {useMainNavigationContext} from 'brandComponents/Header/Subcomponents/MainNavigation/MainNavigationContext';

import styles from './NavigationItemLinkImage.module.scss';

const NavigationItemLinkImage = ({images}) => {
	const {activeLink, activeCategoryLabel} = useMainNavigationContext();

	return (
		<div className={cn(styles['navigation-item-link-image'], 'navigation-item-link-image')} data-nosnippet="">
			{images.map(({id, image}, index) => (
				<div
					key={id + index}
					className={cn(styles['navigation-item-link-image__alternative'], {
						[styles['navigation-item-link-image__alternative--visible']]: activeLink === id,
					})}
					data-nosnippet=""
				>
					<div className={styles['navigation-item-link-image__alternative--visible__label']}>
						<span>{activeCategoryLabel}</span>
					</div>
					<Contentful initialData={image} />
				</div>
			))}
		</div>
	);
};

export default NavigationItemLinkImage;
